var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mag-header-date"},[_vm._v(" Сейчас "),_c('span',[_vm._v(_vm._s(_vm.date.toStringTime()))]),_vm._v(", "+_vm._s(_vm.date.getDate())+" "+_vm._s(_vm.date.toStringMonth())+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }